import type { TOC } from '@ember/component/template-only'
import { StudentDashboardTile } from 'teacher-ui-client/components/tiles/student-dashboard'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { TaskState } from 'teacher-ui-client/components/task-state'
import { StudentDashboardSubheader } from 'teacher-ui-client/components/tiles/student-dashboard/subheader'
import { BasePageSelector } from 'teacher-ui-client/components/base/page-selector'
import { StudentBooksReadOverview } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/books-read/overview'
import { StudentBooksReadEventsDetailed } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/books-read/events-detailed'
import type {
  BooksReadOverviewReportData,
  BooksReadEventsReportData,
} from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import type { Task } from 'ember-concurrency'

interface Args {
  fetchBooksReadOverviewReportTask: Task<BooksReadOverviewReportData | undefined, unknown[]>
  fetchBooksReadEventsReportTask: Task<BooksReadEventsReportData | undefined, unknown[]>
}

interface Signature {
  Args: Args
}
export const DashboardStudentBooksReadPage: TOC<Signature> = <template>
  <StudentDashboardTile
    data-test-student-dashboard-tile="books-read"
    @theme={{themeKey "reading"}}
    @title={{t "pages.reporting.readingEggspress.dashboard.student.booksRead.title"}}
    @icon="phosphor-share-network-fill"
  >
    <TaskState @task={{@fetchBooksReadOverviewReportTask}} @initialLoadingClass="m-3" as |lastValue isRunning|>
      <StudentBooksReadOverview class="w-full" @overviewData={{lastValue.overview}} @isLoading={{isRunning}} />
    </TaskState>
    <StudentDashboardSubheader>
      {{t "pages.reporting.readingEggspress.dashboard.student.recentActivity"}}
    </StudentDashboardSubheader>
    <TaskState @task={{@fetchBooksReadEventsReportTask}} @initialLoadingClass="m-3" as |lastValue isRunning|>
      <StudentBooksReadEventsDetailed class="w-full" @eventsData={{lastValue.events}} @isLoading={{isRunning}} />
      <BasePageSelector
        class="my-4"
        @pageCount={{lastValue.meta.total_pages}}
        @itemCount={{lastValue.meta.total_entries}}
      />
    </TaskState>
  </StudentDashboardTile>
</template>

export default DashboardStudentBooksReadPage
